import CompanyService from "../../../../services/CompanyService";

export class ScheduleTaskEdit {
  personId?: string;
  groupId?: string;
  responsibleUserID?: string;
  activityTypeId?: number;
  activityTypeID?: number;
  creatorUserID?: string;
  scheduledTaskID: number;
  dueDays: number;
  description: string;
  created: string;
  validatorUserID: number;
  repeatPeriod: number;
  repeatFrequency: number;
  repeatEnd: string;
  rememberDays: any;
  notifyCompleted: boolean;
  rememberHour: any;
  rememberMe: boolean;
  weekday: number;
  monthday: number;
  calendar: string;
  taskId: number;

  constructor(loggedUserId?: string, personId?: string, groupId?: string) {
    this.creatorUserID = loggedUserId;
    this.responsibleUserID = loggedUserId;
    this.personId = personId;
    this.activityTypeId = CompanyService.getActivityTypes().find(
      (x) => x.Task && x.TaskDefault
    )?.ActivityTypeID;
    this.groupId = groupId;
    this.rememberMe = false;
    this.weekday = 2; //monday
    this.monthday = 1;
    this.repeatPeriod = 0;
  }
}
